import { Component, OnInit } from '@angular/core';
import { MapViewComponent } from 'app-modules/map-view/components/map-view/map-view.component';

@Component({
  selector: 'app-historical-view',
  templateUrl: './historical-view.component.html',
  standalone: true,
  imports: [MapViewComponent]
})
export class HistoricalViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
